export default class Modal {
    constructor(elem, APP) {
        this.elem = elem
        this.closeButton = this.elem.querySelector('.js-modal-close')
        this.modal = this.elem.querySelector('.js-modal')
        this.modalContents = this.elem.querySelector('.js-modal-contents')
        this.trigger = this.elem.querySelector('.js-modal-trigger')
        // if iframe
        this.iframe = this.elem.querySelector('iframe')
        this.modalOpen = false
    }

    initModal() {
        if(this.trigger !== null) {
            this.trigger.addEventListener('click', () =>  this.openModal())
            this.closeButton.addEventListener('click', () =>  this.closeModal())
            window.addEventListener('keyup', e => {
                if (['esc', 'escape'].includes(e.key.toLowerCase())) {
                    this.closeModal()
                }
            })
        }

    }

    openModal () {

        const videoURL = this.iframe.getAttribute('src');
        console.log(videoURL)
        // autoplay still not quite working consistently
        // iframe read only issue
        // let autoURL = videoURL += "?autoplay=1";
        // this.iframe.setAttribute('src', autoURL);
        // console.log(autoURL)
        
        this.modal.classList.add('is-active')
        this.modalOpen = true

        // copied over legacy scroll stopping for potential use
        // this.$body.addClass('_is_requesting')
        // this.$body.addClass('_is_fixed')
        // this.$elem.addClass('_on_canvas')
        // this.$body.addClass('_has_overlay')
        // this.modalOpen = true
    }

    closeModal() {
        if ( this.iframe !== null ) {
            // oddly this works below
            var iframeSrc = this.iframe.src;
            this.iframe.src = iframeSrc;
        }
        this.modal.classList.remove('is-active')
        this.modalOpen = false
    }

    init() {
        this.initModal()
    }
}